import React from "react";
import {Link} from "react-router-dom";
import {Alert, Box, Button, CardHeader, CircularProgress, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import AppBar from "../app-bar/app-bar";
import {PageContainer} from "../components/common/page-container";
import {canViewTenantUsers, useUser} from "../providers/user-context";

export default function UserManagementLayout({navOpen, toggleNav, activeTab = "users", navigationAction, children}) {
    const {t} = useTranslation();
    const {userFullName, userIdentity, tenantName, tenantId, tenantType, userRole, userLoading, userError, reloadUser} = useUser();
    return <div style={{display: "flex", marginTop: "60px"}}>
        <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
        <PageContainer navOpen={navOpen}>
            {userLoading ? <CircularProgress aria-label={t("Loading")}/> : userError ?
                <Alert severity="error" action={<Button color="inherit" onClick={reloadUser}>{t("Retry")}</Button>}>
                    {t(userError)}</Alert> : tenantId && canViewTenantUsers(tenantType, userRole) ?
                    <React.Fragment key={JSON.stringify([tenantId, userIdentity, userFullName, userRole])}>
                        <CardHeader title={t("UserManagement")}/>
                        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap",
                            gap: 1, borderBottom: 1, borderColor: "divider", mb: 2}}>
                            <Tabs value={activeTab} aria-label={t("UserManagement")}>
                                <Tab component={Link} to="/distributor/users" value="users" label={t("UserManagement")}
                                     id="user-management-users-tab" aria-controls="user-management-users-panel"/>
                                <Tab component={Link} to="/distributor/users/couriers" value="couriers" label={t("CourierManagement")}
                                     id="user-management-couriers-tab" aria-controls="user-management-couriers-panel"/>
                            </Tabs>
                            {navigationAction}
                        </Box>
                        <Box role="tabpanel" id={`user-management-${activeTab}-panel`}
                             aria-labelledby={`user-management-${activeTab}-tab`}>{children}</Box>
                    </React.Fragment> : <Alert severity="warning">
                        {t(activeTab === "users" ? "TenantUsersAccessDenied" : "CourierManagementAccessDenied")}</Alert>}
        </PageContainer>
    </div>;
}
